import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  form: FelaCSS;
}

const styles: IStyles = {
  form: {
    all: 'unset',
    display: 'contents',
  },
};

export default styles;
